<template>
  <popup-modal ref="popup">
    <v-card>
      <v-toolbar color="primary" dark>
        Настройка фильтра
      </v-toolbar>

      <v-card-text class="mt-4">

        <form>

          <date-field-range
              :value="[date1, date2]"
              label="Период"
              @change="
									date1 = $event[0]
									date2 = $event[1]
								"
              :validate="true"
          />

          <v-select
              v-model="reportLocation"
              :items="getLocationsFilter"
              @change="changeLocation"
              multiple
              prepend-icon="mdi-map-marker"
              label="Локации"
              item-text="name"
              item-value="id"
              required
          ></v-select>


<!--          <v-select-->
<!--              v-model="reportType"-->
<!--              :items="getReportsTypes"-->
<!--              @change="changeStatus"-->
<!--              multiple-->
<!--              prepend-icon="mdi-text-box-search"-->
<!--              label="Тип отчета"-->
<!--              item-text="name"-->
<!--              item-value="id"-->
<!--              return-object-->
<!--              required-->
<!--          ></v-select>-->
        </form>
      </v-card-text>

      <!--                Actions-->
      <v-card-actions>
        <div class="flex-grow-1"></div>

        <v-btn @click="Negative" text>{{ $t('common.button_cancel') }}</v-btn>
        <v-btn @click="Positive" color="primary">{{ $t('common.button_ok') }}</v-btn>
      </v-card-actions>
    </v-card>
  </popup-modal>
</template>

<script>
import PopupModal from "@/components/PopupModal";
import DateFieldRange from "@/components/DateFieldRange"
import { mapGetters } from "vuex"
export default {
  name: "DialogReportFilter",
  components: { PopupModal, DateFieldRange },
  data: () => ({

    date1: null,
    date2: null,
    reportLocation: null,

    // Private variables
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),
  methods: {

    changeStatus(){},
    changeLocation(){},

    show(opts = {}) {
      console.log(opts)
      //dateFrom: date | null | undefined
      //dateTo: date | null | undefined
      //locations:
      //status:



      // Once we set our config, we tell the popup modal to open
      this.$refs.popup.open(false, true);

      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },

    Positive() {
      this.$refs.popup.close();
      this.resolvePromise({ answer: "positive", form: {
          date1: this.date1,
          date2: this.date2,
          reportLocations: this.reportLocation,
        } });
    },
    Negative() {
      this.$refs.popup.close();
      this.resolvePromise({ answer: "negative" });
    },
  },
  computed:{
    ...mapGetters('app',["getLocationsFilter", "getReportsTypes"]),
  },
};
</script>
